"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.summary = exports.getSfdcSummary = void 0;

var _msw = require("msw");

var getSfdcSummary = _msw.rest.get('/reporting/roi/salesforce/summary', function (req, res, ctx) {
  return res(ctx.json({
    data: {
      claimedGiftsOpportunitiesSum: 150000,
      closedWonOpportunitiesSum: 50000,
      totalInfluenced: 25000,
      totalSpend: 2500,
      roi: 76
    }
  }));
});

exports.getSfdcSummary = getSfdcSummary;
var summary = [getSfdcSummary];
exports.summary = summary;